var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"userconfirm"}},[_vm._v("userconfirm")])
}
var staticRenderFns = []

export { render, staticRenderFns }